const config = {
    "app": {
        organization: 'Taiwan Accreditation Foundation',
        title: 'Training Affairs Operation Web',
        search: false,
        registration: true
    },
    "ajax": {
        "baseURL": "/taos-server/"
        // "baseURL":"http://localhost:4000"
    },
    "i18n": {
        "language": "zh-TW",
        "debug": false
    },
    "currency": {
        "pattern": '$0,0.00'
    },
    "numeral": {
        "pattern": {
            "integer": '0,0',
            "float": '0,0.00'
        }
    },
    "time": {
        "pattern": {
            "datetime": "YYYY/MM/DD HH:mm:ss",
            "date": "YYYY/MM/DD",
            "time": "HH:mm:ss"
        }
    },
    responsive: {
        minWidth: 320,
        width: [0, 1366],
        height: [0, 768]
    },
    theme: {
        brand: {
            logo: '/brand/logo.svg',
            training: '/brand/training.jpg',
            teachers: '/brand/teachers.jpg',
            students: '/brand/students.jpg',
            courses: '/brand/courses.jpg',
            information: '/brand/information.jpg',
            searchbar: '/brand/searchbar.png',
            backgroundImage: '/brand/background.jpg',
        },
        palette: {
            text: {
                primary: '#263238',
                secondary: '#546e7a',
                disabled: 'rgba(0, 0, 0, 0.54)'
            },
            primary: {
                main: '#981E97',
                light: '#C98BDB',
                dark: '#660068',
                contrastText: '#ffffff'
            },
            secondary: {
                main: '#E56910',
                light: '#ff9945',
                dark: '#ac3a00',
                contrastText: '#ffffff'
            },
            success: {
                main: '#00695c',
                light: '#439889',
                dark: '#003d33',
                contrastText: '#ffffff'
            },
            info: {
                main: '#0097a7',
                light: '#56c8d8',
                dark: '#006978',
                contrastText: '#ffffff'
            },
            error: {
                main: '#C23030',
                light: '#fb645a',
                dark: '#8a0009',
                contrastText: '#ffffff'
            },
            warning: {
                main: '#e68523',
                light: '#ffb554',
                dark: '#ae5700',
                contrastText: '#ffffff'
            },
            prompt: {
                main: '#106BA3',
                light: '#5599d5',
                dark: '#004174',
                contrastText: '#ffffff'
            },
        },
        typography: {
            // In Chinese and Japanese the characters are usually larger,
            // so a smaller fontsize may be appropriate.
            htmlFontSize: 16,
            fontSize: 14,
            fontFamily:  '-apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, ' +
                'Helvetica Neue, sans-serif, PingFang TC, Noto Sans TC, Microsoft JhengHei',
            h1: {
                fontWeight: 400,
                fontSize: "3rem",
                lineHeight: 1.167,
                letterSpacing: "0em"
            },
            h2: {
                fontWeight: 400,
                fontSize: '2.25rem',
                lineHeight: 1.201,
                letterSpacing: "0em"
            },
            h3: {
                fontWeight: 400,
                fontSize: "1.75rem",
                lineHeight: 1.235,
                letterSpacing: "0.00735em"
            },
            h4: {
                fontWeight: 400,
                fontSize: "1.5rem",
                lineHeight: 1.334,
                letterSpacing: "0.0075em"
            },
            h5: {
                fontSize: '1.25rem',
                fontWeight: 500,
                lineHeight: 1.6,
                letterSpacing: "0.0075em"
            },
            h6: {
                fontWeight: 500,
                fontSize: "1.1rem",
                lineHeight: 1.75,
                letterSpacing: "0.00938em"
            },
            button: {
                fontSize: '1rem',
                fontFamily:  '-apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, ' +
                    'Helvetica Neue, sans-serif, PingFang TC, Noto Sans TC, Microsoft JhengHei',
            },
            caption: {
                fontFamily:  '-apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, ' +
                    'Helvetica Neue, sans-serif, PingFang TC, Noto Sans TC, Microsoft JhengHei',
            },
            overline: {
                fontFamily:  '-apple-system, BlinkMacSystemFont, Roboto, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, ' +
                    'Helvetica Neue, sans-serif, PingFang TC, Noto Sans TC, Microsoft JhengHei',
            }
        }
    }
}

export default config;